import React from 'react';
import { IconProps } from '../../../types/components';

export default function StockIndicator({ iconClass, width }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 16 16"
      className={iconClass}
      width={width}
      fill="currentColor"
    >
      <circle cx="8" cy="8" r="8" />
      <circle cx="8" cy="8" r="6" stroke="white" strokeOpacity="0.8" strokeWidth="4" />
    </svg>
  );
}
